( function( $ ) {
	'use strict';

	const $sliders = $( '.product-slider .swiper' );

	if ( !$sliders.length ) {
		return;
	}

	( function() {

		const sliders = [];

		// const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
		const hasStackable = $sliders.toArray().some( s => $( s ).closest( '.product-slider' ).is( '.stack-on-mobile' ) );

		const initSliders = () => {

			$sliders.each( function( index, sliderEl ) {

				const $slider = $( sliderEl ).addClass( 'swiper-' + index );

				const windowWidth = $(window).width();

				let isConstrained = false;
				let $container = $slider.closest( '.is-slider-container' );
				if ( ! $container.length ) {
					$container = $slider.closest( '.wp-block-columns' );
					//are we inside a column inside of a tab?
					if ( !$container.length || !$container.parent().is( '.wp-block-colibri-tabs__panel' ) ) {
						$container = [];
					}
				}
				isConstrained = $container.length > 0;

				//adjust breakpoints when used in a .is-target-container wrapper
				const colWidth = isConstrained ? ((1400-34-32)/3): 0; //will most likely resolve to 445px

				const slidesPerView   = $slider.closest( '.product-slider' ).data( 'column-count' );
				const sliderAlignment = $slider.closest( '.product-slider' ).data( 'slider-alignment' );

				if ( !$slider.find( '.swiper-button-next' ).length ) {
					//dynamically inject navigation buttons, were absent
					$slider.find( '.swiper-wrapper' ).after( '<div class="swiper-button-next"></div><div class="swiper-button-prev"></div>' );
				}

				let breakpoints = null;

				//const minCardWidth = 290;
				//const maxCardWidth = 350;

				switch ( slidesPerView ) {
					//todo: maybe take into account the width of the vertical scrollbar
					case 2: {
						breakpoints = {
							[ 375 + colWidth ]: {
								slidesPerView: 1.2,
							},
							[ 730 + colWidth ]: {
								slidesPerView: 2.2,
							},
						}
						break;
					}

					case 3: {
						breakpoints = isConstrained ?
							{
								[ 1024 ]: {
									slidesPerView: 2.2,
									spaceBetween: 24,
								},
								[ 1350 ]: {
									slidesPerView: 3.2,
									spaceBetween: 32,
								},
							}
							: {
								[ 375 + colWidth ]: {
									slidesPerView: 1.2,
								},
								[ 730 + colWidth ]: {
									slidesPerView: 2.2,
								},
								[ 980 + colWidth ]: {
									slidesPerView: 3.2,
								},
							}
						break;
					}

					case 4: {
						breakpoints = {
							[ 375 + colWidth ]: {
								slidesPerView: 1.2,
							},
							[ 730 + colWidth ]: {
								slidesPerView: 2.2,
							},
							[ 980 + colWidth ]: {
								slidesPerView: 3.2,
							},
							[ 1168 + colWidth ]: {
								slidesPerView: 4.2,
							},
						}
						break;
					}

					default : {
						breakpoints = {
							[ 375 + colWidth ]: {
								slidesPerView: 1.2,
							},
						};
					}
				}


				const args = {
					slidesPerView: 1.2,
					centerSlides: !isConstrained,
					centeredSlidesBounds: false,
					breakpoints,
					centerInsufficientSlides: 'left' !== sliderAlignment,
					garbCursor: true,
					resistance: false,
					spaceBetween: 16,
					allowTouchMove: true,
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev'
					},
					watchSlidesProgress: true,
					on: {
						breakpoint: function () {
							this.updateSlidesClasses();
						},
						slideChange: function () {
							if ( this.isEnd ) {
								sliderEl.classList.add('swiper-reach-end');
							} else {
								sliderEl.classList.remove('swiper-reach-end');
							}
						},
					}
				};

				sliders.push( new Swiper( sliderEl, args ) );
			} );
		} // initSliders()

		const setSlidersStructuredData = () => {
			const seoPromotedTab = document.querySelector( '[data-seo-promoted]' );

			let seoPromotedSlider = null;

			if ( seoPromotedTab ) {
				const seoPromotedPanelId = seoPromotedTab.getAttribute('aria-controls');

				if ( seoPromotedPanelId ) {
					const seoPromotedPanel = document.getElementById( seoPromotedPanelId );

					if ( seoPromotedPanel ) {
						seoPromotedSlider = seoPromotedPanel.querySelector( '.product-slider .swiper' );
					}
				}
			}

			if ( ! seoPromotedSlider ) {
				seoPromotedSlider = document.querySelector( '.product-slider .swiper' );
			}

			if ( ! seoPromotedSlider ) {
				return;
			}

			const cards = seoPromotedSlider.querySelectorAll( '.swiper-slide' );
			const cardsLength = cards.length;
			let structuredDataItems = '';

			cards.forEach( function( cardEl, cardIndex ) {
				// Product Title.
				const cardTitleEl = cardEl.querySelector( '.card-title' );
				const cardTitle = cardTitleEl ? cardTitleEl.textContent.replace(/"/g, '\\"') : '';

				// Product Description.
				const packageDescClasses = ['.package-items-text', '.package-items', '.product-description'];
				let cardDescEl = null;
				for (const packageDescClass of packageDescClasses) {
					cardDescEl = cardEl.querySelector( packageDescClass );
					if ( cardDescEl ) {
						break;
					}
				}
				const cardDesc = cardDescEl ? cardDescEl.innerHTML.replace(/"/g, '\\"') : '';

				// Product Link.
				const cardLinkEl = cardEl.querySelector( '.details-page-link' );
				const cardLink = cardLinkEl ? cardLinkEl.getAttribute('href') : '';

				// Product Price
				let cardPrice = cardEl.querySelector( '.discounted-price .price-value' );
				if ( ! cardPrice ) {
					cardPrice = cardEl.querySelector( '.regular-price .price-value' );
				}

				let cardPriceValue = '';

				if ( cardPrice ) {
					cardPriceValue = cardPrice.textContent;
				}

				// Offers Category
				let offersCategory = 'Paid';
				if ( cardPriceValue != '' && cardPriceValue == 0 ) {
					offersCategory = 'Free';
				}

				// Course Workload.
				let hoursText = '';
				let hoursTextWrapper = cardEl.querySelector( '.included-hours' );
				if ( hoursTextWrapper ) {
					hoursText = hoursTextWrapper.textContent.replace(/"/g, '\\"');

					const searchStr1 = 'Total Hours: ';
					const index1 = hoursText.indexOf( searchStr1 ) + searchStr1.length;

					if ( index1 !== -1 ) {
						hoursText = hoursText.substring( index1 );

						const searchStr2 = ' hrs';
						const index2 = hoursText.indexOf( searchStr2 );
						hoursText = hoursText.substring( 0, index2 );
					}
				} else {
					const searchStr1 = '-hour';
					for ( const li of cardDescEl.querySelectorAll( 'li' ) ) {
						const liContent = li.textContent.toLowerCase();
						if ( liContent.includes( searchStr1 ) ) {
							hoursText = liContent.trim();
							const index = hoursText.indexOf( searchStr1 );
							hoursText = hoursText.substring( 0, index );
						}
					}
				}

				if ( hoursText ) {
					hoursText = `PT${hoursText}H`;
				}

				// Structured Data Items

				structuredDataItems += `{
						"@type": "ListItem",
						"position": ${cardIndex + 1},
						"item": {
							"@type": "Course",
							"url":"${cardLink}",
							"name": "${cardTitle}",
							"description": "${cardDesc}",
							"provider": {
								"@type": "Organization",
								"name": "${window.colibri.analytics[0].brand}",
								"sameAs": "${window.location.origin}"
							},
							"offers": {
								"@type": "Offer",
								"category": "${offersCategory}",
								"price": "${cardPriceValue}",
								"priceCurrency": "USD"
							},
							"hasCourseInstance": [
								{
									"@type": "CourseInstance",
									"courseMode": "Blended",
									"courseWorkload": "${hoursText}"
								}
							]
						}
					}`;

				if ( cardIndex < ( cardsLength - 1 ) ) {
					structuredDataItems += ',';
				}
			});

			const structuredDataText = `{
				"@context": "https://schema.org",
				"@type": "ItemList",
				"itemListElement": [
					${structuredDataItems}
				]
			}`;

			const script = document.createElement( 'script' );
			script.setAttribute( 'type', 'application/ld+json' );
			script.textContent = structuredDataText;
			document.head.appendChild( script );
		}

		/**
		 * Making sure all buttons are aligned despite different height of title/pricing components
		 * TODO: Affirm may possibly load prices after this function. Run it after affirm prices are fully loaded if that's the case.
		 */
		const equalizeSlidesHeight = () => {
			const targetElements = ['.card-title', '.pricing-container', '.package-items-text-intro'];
			const getMaxHeight = (elements) => {
				let maxHeight = 0;
				elements.forEach((el) => {
					el.style.minHeight = 'auto'; // Reset min-height before calculating
					const height = el.offsetHeight;
					if (height > maxHeight) {
						maxHeight = height;
					}
				});
				return maxHeight;
			};

			const setMinHeight = (elements, height) => {
				elements.forEach((el) => {
					el.style.minHeight = `${height}px`;
				});
			};

			const equalizeHeightsForClass = (selector) => {
				const elements = document.querySelectorAll(`.swiper-slide ${selector}`);
				const maxHeight = getMaxHeight(elements);
				setMinHeight(elements, maxHeight);
			};

			targetElements.forEach((selector) => {
				equalizeHeightsForClass(selector);
			});
		};

		// Re-invoke equalizeSlidesHeight() when .has-affirm is added
		const observePriceClassChanges = () => {
			const priceElements = document.querySelectorAll('.swiper-slide .price');

			priceElements.forEach((priceElement) => {
				const observer = new MutationObserver(() => {
					if (priceElement.classList.contains('has-affirm')) {
						equalizeSlidesHeight();
					}
				});

				observer.observe(priceElement, { attributes: true, attributeFilter: ['class'] });
			});
		};

		/**
		 *
		 */
		const listenForFilterRequests = () => {
			const e = 'COLIBRI::PACKAGE_LICENSE_LEVEL_TRANSITION_FILTER';
			if ( typeof window?.colibri?.eventsQueue?.[ e ] !== 'undefined' ) {
				//looks like we have missed one request already
				filterSlides( e, window.colibri.eventsQueue[ e ] );
			}
			$( window ).bind( e, filterSlides );
		}

		const filterSlides = ( e, data ) => {
			const codes = data?.showPackages.split( ',' );

			if ( !codes.length || codes[ 0 ] === 'all' ) {
				//un-filter all cards
				const $cardsToShow = $sliders.find( '.card--product-slide:not(:visible)' );
				$cardsToShow.each( ( idx, card ) => {
					$( card ).show();
				} );
				if ( $cardsToShow.length ) {
					updateSliders();
				}
				return;
			}

			var countFlipped = 0;
			$sliders.find( '.card--product-slide' ).each( ( idx, card ) => {
				const $card = $( card );
				const productCode = $card.attr( 'id' ).replace( 'product-', '' ).replace( 'course-', '' );
				if ( codes.indexOf( productCode ) === - 1 ) {
					if ( $card.is( ':visible' ) ) {
						$card.hide();
						countFlipped ++;
					}
				} else {
					if ( !$card.is( ':visible' ) ) {
						$card.show();
						countFlipped ++;
					}
				}
			} );

			if ( countFlipped ) {
				updateSliders();
			}
		} // filterSlides()

		/**
		 *
		 */
		const updateSliders = () => {
			sliders.forEach( swiper => swiper.update() );
		}

		/**
		 * boot up
		 */
		if ( typeof window.swiper === 'undefined' ) {
			// load swiper slider scripts and styles
			var scriptUrl = 'https://cdn.jsdelivr.net/npm/swiper@9.0.3/swiper-bundle.min.js';
			var styleUrl = 'https://cdn.jsdelivr.net/npm/swiper@9.0.3/swiper-bundle.min.css';

			$( 'head' ).append( '<link rel="stylesheet" type="text/css" href="' + styleUrl + '">' );

			$( document ).ready( function() {
				$.getScript( scriptUrl, function() {
					initSliders();
					listenForFilterRequests();
					setSlidersStructuredData();
					equalizeSlidesHeight();
					observePriceClassChanges();
				} );
			} );

		} else {
			initSliders();
			listenForFilterRequests();
			setSlidersStructuredData();
			equalizeSlidesHeight();
			observePriceClassChanges();
		}

	} )();

} )( jQuery );
